import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { connect } from 'react-redux';
import { formValueSelector, change, reduxForm } from 'redux-form';
import { GoogleMap, InfoBox, MarkerF, OverlayView, OverlayViewF } from "@react-google-maps/api";

import ListingItem from '../ListingItem/ListingItem';
import CustomOverlayView from './CustomOverlayView';
import CurrencyConverter from '../../CurrencyConverter';
import messages from '../../../locale/messages';

import submit from '../SearchForm/submit';
import { setPersonalizedValues } from '../../../actions/personalized';
import { searchListing } from '../../../actions/searchListing';
import { mapThemeStyle } from '../../../helpers/mapThemeStyle';
import { mapResults, getMarkerIcon, getPixelPositionOffset, containerStyle, refs } from '../../../helpers/mapResultsHelper';

import lightMapPinIcon from '../../../../public/SiteIcons/mapPinSmallLight.svg'
import darkMapPinIcon from '../../../../public/SiteIcons/mapPinSmallDark.svg'

import s from './MapResults.css';

class MapResults extends React.Component {

  static propTypes = {
    initialFilter: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      personCapacity: PropTypes.number,
      dates: PropTypes.string
    }),
    results: PropTypes.array,
    personalized: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    change: PropTypes.any,
    handleSubmit: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      zoom: 12,
      center: {
        lat: 0,
        lng: 0
      },
      markers: [],
      bounds: {},
      searchByMapResults: false,
      isMapDrag: false,
      isMapZoom: false,
      isMapPositionChanged: false,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{
            color: '#a4ddf5'
          }]
        }
      ]
    };
  }

  componentDidMount() {
    const { results, initialFilter, personalized, theme } = this.props;
    const { hover, center } = this.state;
    let bounds = new google.maps.LatLngBounds(), southWest, northEast;
    if (initialFilter?.lat && initialFilter?.lng) {
      southWest = new google.maps.LatLng(initialFilter?.sw_lat, initialFilter?.sw_lng);
      northEast = new google.maps.LatLng(initialFilter?.ne_lat, initialFilter?.ne_lng);
      bounds.extend(southWest);
      bounds.extend(northEast);
    }
    let positions = [], defaultCordinates, data, centerValue;
    if (results?.length > 0) {
      results?.map((item) => {
        data = mapResults(item, hover);
        positions.push(data);
        bounds.extend(new google.maps.LatLng(item?.lat, item?.lng));
      })
      this.setState({ markers: positions, bounds });
    } else {
      if (personalized?.lat && personalized?.lng) {
        centerValue = {
          lat: personalized?.lat,
          lng: personalized?.lng
        };
        defaultCordinates = new google.maps.LatLng(centerValue?.lat, centerValue?.lng);
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds, center: centerValue });
      } else if (initialFilter?.lat && initialFilter?.lng) {
        centerValue = {
          lat: initialFilter?.lat,
          lng: initialFilter?.lng
        };
        defaultCordinates = new google.maps.LatLng(centerValue?.lat, centerValue?.lng);
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds, center: centerValue });
      } else {
        defaultCordinates = new google.maps.LatLng(center?.lat, center?.lng);
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds });
      }
    }
    this.setState({
      styles: mapThemeStyle(theme)
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { results, initialFilter, searchByMapValue, markerHighlight, theme } = nextProps;
    const { searchByMapResults } = this.state;
    let { hover, center } = this.state, bounds = new google.maps.LatLngBounds(), southWest, northEast;
    this.setState({ searchByMapResults: searchByMapValue });
    let defaultCordinates, centerValue, positions = [], data, position;

    if (initialFilter?.lat && initialFilter?.lng) {
      southWest = new google.maps.LatLng(initialFilter?.sw_lat, initialFilter?.sw_lng);
      northEast = new google.maps.LatLng(initialFilter?.ne_lat, initialFilter?.ne_lng);
      bounds.extend(southWest);
      bounds.extend(northEast);
    }

    if (results?.length > 0) {
      results?.map((item) => {
        position = new google.maps.LatLng(item?.lat, item?.lng);
        if (markerHighlight) hover = markerHighlight?.id == item?.id ? true : false;
        bounds.extend(position);
        data = mapResults(item, hover);
        positions.push(data);
      });
      this.setState({
        markers: positions,
        bounds
      });
    } else {
      if (initialFilter?.lat && initialFilter?.lng) {
        centerValue = {
          lat: initialFilter?.lat,
          lng: initialFilter?.lng
        };
        defaultCordinates = new google.maps.LatLng(centerValue?.lat, centerValue?.lng);
        bounds.extend(defaultCordinates);
        if (!searchByMapResults) {
          this.setState({ bounds, center: centerValue });
        }
      } else {
        defaultCordinates = new google.maps.LatLng(center?.lat, center?.lng);
        bounds.extend(defaultCordinates);
        if (!searchByMapResults) {
          this.setState({ bounds });
        }
      }
      this.setState({ markers: [] });
    }
    this.setState({ styles: mapThemeStyle(theme) })
  }

  componentWillUnmount() {
    const { change } = this.props;
    change('initialLoad', true);
  }

  handleFitBounds = async (map) => {
    const { bounds } = this.state;
    const { initialLoad, initialFilter, results, personalized } = this.props;
    let southWest, northEast, boundsData, new_bounds;
    if (results?.length > 0) {
      boundsData = bounds;
    } else if (initialFilter?.lat && initialFilter?.lng) {
      new_bounds = new google.maps.LatLngBounds();
      southWest = new google.maps.LatLng(initialFilter?.sw_lat, initialFilter?.sw_lng);
      northEast = new google.maps.LatLng(initialFilter.ne_lat, initialFilter?.ne_lng);
      new_bounds.extend(southWest);
      new_bounds.extend(northEast);
      boundsData = new_bounds;
    } else if (personalized?.southWest && personalized?.northEast) {
      new_bounds = new google.maps.LatLngBounds();
      new_bounds.extend(personalized?.southWest);
      new_bounds.extend(personalized?.northEast);
      boundsData = new_bounds;
    } else {
      new_bounds = new google.maps.LatLngBounds();
      southWest = new google.maps.LatLng(9.854550803628602, 80.12749270688475);
      northEast = new google.maps.LatLng(46.588831619427665, -120.63917188786621);
      new_bounds.extend(southWest);
      new_bounds.extend(northEast);
      boundsData = new_bounds;
    }
    if (map && initialLoad && boundsData != {}) {
      map.fitBounds(boundsData);
    }
    refs.map = map;
  }

  getCenter = (e) => {
    let center, lat, lng;
    if (refs?.map) {
      center = refs?.map?.getCenter();
      lat = center?.lat();
      lng = center?.lng();
    }
  }

  handleMarkerClick = (targetMarker) => {
    const { theme } = this.props;
    this.setState({
      markers: this.state && this.state.markers && this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: true,
            icon: theme === 'dark' ? darkMapPinIcon : lightMapPinIcon,
            hovered: true
          };
        } else {
          return {
            ...marker,
            showInfo: false,
            icon: theme === 'dark' ? darkMapPinIcon : lightMapPinIcon,
            hovered: false
          };
        }
        return marker;
      }),
      center: {
        lat: targetMarker.lat,
        lng: targetMarker.lng
      },
      bounds: null
    });
  }

  handleMarkerClose = (targetMarker) => {
    const { theme } = this.props;
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: false,
            icon: theme === 'dark' ? darkMapPinIcon : lightMapPinIcon,
            hovered: false
          };
        }
        return marker;
      }),
    });
  }

  handleOnDragStart = async () => {
    const { change } = this.props;
    this.setState({
      isMapDrag: true
    });
    await change('initialLoad', false);
  }

  handleZoomChanged = async () => {
    const { isMapZoom } = this.state;
    if (refs?.map && isMapZoom === false) {
      this.setState({ isMapZoom: !isMapZoom });
    }

    if (refs?.map && isMapZoom) {
      this.setState({ isMapPositionChanged: true });
    }
  }

  handleOnDragEnd = async () => {
    const { isMapDrag } = this.state;

    if (refs?.map && isMapDrag) {
      this.setState({ isMapPositionChanged: true });
    }
  }

  handleSearchThisArea = async () => {
    const { change, handleSubmit, setPersonalizedValues } = this.props;

    if (refs?.map) {
      const center = refs.map.getCenter();
      const zoom = refs.map.getZoom();
      const bounds = refs.map.getBounds();
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();

      await Promise.all([
        change('initialLoad', false),
        change('searchByMap', true),
        change('lat', center.lat()),
        change('lng', center.lng()),
        setPersonalizedValues({ name: 'lat', value: Number(center.lat()) }),
        setPersonalizedValues({ name: 'lng', value: Number(center.lng()) }),
        change('sw_lat', southWest.lat()),
        change('sw_lng', southWest.lng()),
        change('ne_lat', northEast.lat()),
        change('ne_lng', northEast.lng()),
        change('zoomLevel', zoom),
        change('currentPage', 1)
      ]);
      await handleSubmit();
      this.setState({ isMapPositionChanged: false });
    }
  }

  render() {
    const { markers, styles, isMapPositionChanged } = this.state;
    const { guests, totalPrice } = this.props;

    return (
      <div className={cx(s.mapCanvas, 'searchMap')}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          defaultZoom={12}
          onLoad={this.handleFitBounds}
          onDragStart={this.handleOnDragStart}
          onDragEnd={this.handleOnDragEnd}
          onZoomChanged={() => this.handleZoomChanged()}
          onBoundsChanged={this.handleFitBounds(refs.map)}
          clickableIcons={false}
          onCenterChanged={(e) => this.getCenter(e)}
          options={{
            minZoom: 2,
            maxZoom: 18,
            mapTypeControl: false,
            streetViewControl: false,
            navigationControl: false,
            backgroundColor: '',
            streetViewControl: false,
            zoomControlOptions: { position: google.maps.ControlPosition.LEFT_TOP },
            draggable: true,
            fullscreenControl: false,
            styles: styles
          }}
        >
          {markers?.map((marker, key) => {
            let icon = getMarkerIcon(marker);
            let pixelOffset = new google.maps.Size(-140, 0);
            return (
              <div key={key}>
                <MarkerF
                  position={marker.position}
                  clickable={true}
                  icon={{ url: icon, scale: 5 }}
                  onClick={() => this.handleMarkerClick(marker)}
                  key={Math.random()}
                  zIndex={100 + key}
                >
                  {
                    !marker.showInfo && <OverlayViewF
                      position={{ lat: marker.lat, lng: marker.lng }}
                      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                      getPixelPositionOffset={getPixelPositionOffset}
                    >
                      <div className={cx(s.customMarkerContainer, { [s.hoveredMarker]: marker.hovered == true })}>
                        <div className={s.customMarkerPointBorder}></div>
                        <div className={cx(s.customMarkerContent)}>
                          {
                            <CurrencyConverter
                              amount={totalPrice ? marker?.oneTotalPrice : marker?.basePrice}
                              from={marker?.currency}
                            />
                          }
                        </div>
                        <div className={cx(s.customMarkerPoint)}></div>
                      </div>
                    </OverlayViewF>
                  }
                  {
                    marker?.showInfo && <InfoBox
                      onCloseClick={() => { this.handleMarkerClose(marker) }}
                      options={{
                        closeBoxURL: ``,
                        alignBottom: true,
                        boxStyle: {
                          width: "350px",
                          paddingTop: '50px',
                          paddingBottom: '35px',
                          minHeight: "145px",
                          maxWidth: "350px",
                          overflow: "hidden"
                        },
                        pixelOffset: pixelOffset,
                        enableEventPropagation: true,
                      }}
                      position={marker.position}
                      zIndex={330}
                    >
                      <div>
                        <ListingItem
                          id={marker?.id}
                          basePrice={marker?.basePrice}
                          currency={marker?.currency}
                          title={marker?.title}
                          beds={marker?.beds}
                          personCapacity={marker?.personCapacity}
                          roomType={marker?.roomType}
                          coverPhoto={marker?.coverPhoto}
                          listPhotos={marker?.listPhotos}
                          bookingType={marker?.bookingType}
                          reviewsCount={marker?.reviewsCount}
                          reviewsStarRating={marker?.reviewsStarRating}
                          wishListStatus={marker?.wishListStatus}
                          isListOwner={marker?.isListOwner}
                          onCloseClick={() => this.handleMarkerClose(marker)}
                          showMap={true}
                          personCount={guests}
                          oneTotalPrice={marker?.oneTotalPrice}
                        />
                      </div>
                    </InfoBox>
                  }
                </MarkerF>
              </div>
            )
          })}
          <></>
        </GoogleMap>
        {isMapPositionChanged && (
          <div className={s.searchThisAreaContainer}>
            <button className={s.searchThisAreaBtn} onClick={this.handleSearchThisArea}>
              <FormattedMessage {...messages.searchThisArea} />
            </button>
          </div>
        )}
      </div>
    );
  }
}

MapResults = reduxForm({
  form: 'SearchForm', // a unique name for this form
  onSubmit: submit,
  destroyOnUnmount: false,
})(MapResults);

const selector = formValueSelector('SearchForm');

const mapState = (state) => ({
  results: state?.search?.data,
  personalized: state?.personalized,
  searchByMapValue: selector(state, 'searchByMap'),
  initialLoad: selector(state, 'initialLoad'),
  markerHighlight: selector(state, 'markerHighlight'),
  guests: Number(selector(state, 'personCapacity')),
  theme: state?.currency?.theme,
  totalPrice: state?.personalized?.totalPrice,
});

const mapDispatch = {
  change,
  setPersonalizedValues,
  searchListing
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(MapResults)));